const BASE_PREFIX = "files";

const ADD_FILE = `${BASE_PREFIX}/addFile`;
const DELETE_FILE = `${BASE_PREFIX}/deleteFile`;
const GET_FILES_REQUEST = `${BASE_PREFIX}/getFilesRequest`;
const GET_FILES_SUCCESS = `${BASE_PREFIX}/getFilesSuccess`;
const RESET_TO_INITIAL = `${BASE_PREFIX}/resetToInitial`;

export { ADD_FILE, DELETE_FILE, GET_FILES_REQUEST, GET_FILES_SUCCESS, RESET_TO_INITIAL };